import { useQuery } from "react-query";
import { getLateFeeConfigs } from "../services/finance/lateFeeConfig";
import { PagedRequestType } from "../types/PagedResults";
import { Key_lateFeeConfigs } from "../utils/constants";

export const useGetLateFeeConfigsQuery = (data: PagedRequestType, options:any= null) =>
  useQuery(
    [Key_lateFeeConfigs, JSON.stringify(data)],
    () => getLateFeeConfigs(data), 
    options?{...options}:{}
  );